import React from "react"
import Skeleton from "react-loading-skeleton"

function CardNewsSkeleton() {
  return (
    <div className="uk-card uk-card-default uk-border-rounded">
      <div className="uk-card-media-top uk-width-1-1 uk-height-medium">
        <Skeleton className="uk-height-1-1 uk-width-1-1" />
      </div>
      <div className="uk-card-body">
        <h3 className="uk-card-title uk-text-left">
          <Skeleton />
        </h3>
        <Skeleton height={12} />
        <Skeleton height={12} />
        <Skeleton height={12} />
        <Skeleton height={12} />
      </div>
    </div>
  )
}

export default CardNewsSkeleton
